import { useGetExamCourseByExamCourseCodeQuery } from '@exam-center/graphql';
import { createContext, useMemo } from 'react';

import type { ExamCourse, ExamCourseContextValue, ExamCourseProviderProps } from './types';

const ExamCourseContext = createContext<ExamCourseContextValue | undefined>(undefined);

export default function ExamCourseProvider(props: Readonly<ExamCourseProviderProps>) {
  const { children, examCourseCode } = props;

  const {
    data,
    loading: isLoading,
    error,
  } = useGetExamCourseByExamCourseCodeQuery({
    variables: {
      getExamCourseByExamCourseCodeInput: {
        examCourseCode,
      },
    },
    skip: !examCourseCode,
  });

  const contextValue: ExamCourseContextValue = useMemo(() => {
    return {
      examCourse: data?.ecGetExamCourseByExamCourseCode.examCourse as ExamCourse,
      loading: isLoading,
      error,
    };
  }, [data?.ecGetExamCourseByExamCourseCode.examCourse, isLoading, error]);

  return <ExamCourseContext.Provider value={contextValue}>{children}</ExamCourseContext.Provider>;
}

export { ExamCourseContext };
